import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Debug: Display browser/user timezone information on page load
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const timezoneOffset = new Date().getTimezoneOffset();
const offsetHours = -timezoneOffset / 60;
const offsetString = `UTC${offsetHours >= 0 ? '+' : ''}${offsetHours}`;
console.log(`[Timezone Debug] Browser timezone: ${timezone} (${offsetString})`);

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
